export default [{
    title: "Tributación",
    fontIcon: "file-contract",
    resource: "Tributacion",
    action: "ver-tributacion",
    children: [{
            title: "Dashboard",
            icon: "LayoutIcon",
            resource: "Tributacion",
            action: "ver-tributacion-dashboard",
        },
        {
            title: "Configuracion",
            icon: "SettingsIcon",
            resource: "Tributacion",
            action: "ver-tributacion-configuracion",
            children: [{
                    route: "configuracion-impuesto-renta",
                    title: "Parámetros RDEP",
                    resource: "Tributacion",
                    action: "ver-tributacion-parametros",
                },
                //diego
                {
                    route: "tributacion-configuracion-paises",
                    title: "Paises",
                    resource: "Tributacion",
                    action: "ver-tributacion-configuracion-paises"

                },
                {
                    route: "tributacion-configuracion-aduanero",
                    title: "DistritoAduanero",
                    resource: "Tributacion",
                    action: "ver-tributacion-configuracion-distrito_aduanero"

                },
                {
                    route: "tributacion-configuracion-fideicomiso",
                    title: "Tipo Fideicomiso",
                    resource: "Tributacion",
                    action: "ver-tributacion-configuracion-fideicomiso",
                },
                {
                    route: "tributacion-configuracion-forma-pago",
                    title: "Forma de Pago/Cobro",
                    resource: "Tributacion",
                    action: "ver-tributacion-configuracion-forma-pago",
                },
                {
                    route: "tributacion-configuracion-sustento-comprobante",
                    title: "Sustento del Comprobante",
                    resource: "Tributacion",
                    action: "ver-tributacion-configuracion-sustento-comprobante",
                }, {
                    route: "tributacion-configuracion-retencion-iva",
                    title: "Retencion de IVA",
                    resource: "Tributacion",
                    action: "ver-tributacion-configuracion-retencion-iva",
                }, {
                    route: "tributacion-configuracion-tipo-exportacion-ingreso-exterior",
                    title: "Exportacion/Ingreso Exterior",
                    resource: "Tributacion",
                    action: "ver-tributacion-configuracion-tipo-exportacion-ingreso-exterior",
                },
                /* Jose Pacheco */
                {
                    route: "tributacion-configuracion-ciudades",
                    title: "Ciudades",
                    resource: "Tributacion",
                    action: "ver-tributacion-configuracion-ciudades"

                },
                {
                    route: "tributacion-configuracion-CierreSRI",
                    title: "Cierre SRI",
                    resource: "Tributacion",
                    action: "ver-tributacion-configuracion-CierreSRI"

                },
                {
                    route: "tributacion-configuracion-tipo-comprobante",
                    title: "Tipo Comprobante",
                    resource: "Tributacion",
                    action: "ver-tributacion-configuracion-tipo-comprobante"

                },
                {
                    route: "tributacion-configuracion-punto-emision",
                    title: "Punto Emision",
                    resource: "Tributacion",
                    action: "ver-tributacion-configuracion-punto-emision"

                },
            ],
        },
        {
            title: "Mantenimiento",
            icon: "EditIcon",
            resource: "Tributacion",
            action: "ver-tributacion-mantenimiento",
            children: [{
                    route: "secuencial-documentos-emitidos",
                    title: "Secuencial Documentos",
                    resource: "Tributacion",
                    action: "ver-tributacion-secuencial",
                },

                //ventana para otorgar permisos a las diferentes ventanas de tributación
                {
                    route: "tributacion-permisos-ventanas-tributacion",
                    title: "Permisos Ventanas Tributación",
                    // resource: "Tributacion",
                    // action: "ver-tributacion-permisos-ventanas-tributacion",
                },
                //parametrizaciones tributacion 2022
                {
                    title: "Parametrizaciones ATS",
                    resource: "Tributacion",
                    action: "ver-tributacion-parametrizaciones",
                    children: [{
                            route: "tributacion-tipo-transaccion",
                            title: "Tipo de transacción",
                            resource: "Tributacion",
                            action: "ver-tributacion-tipo-transaccion",
                        },

                        {
                            route: "tributacion-conceptos-retencion-fuente",
                            title: "Conceptos de Retención",
                            resource: "Tributacion",
                            action: "ver-tributacion-conceptos-retencion-fuente",
                        },
                        {
                            route: "tributacion-tipo-comprobantes",
                            title: "Tipos de Comprobantes",
                            resource: "Tributacion",
                            action: "ver-tributacion-tipo-comprobantes",
                        },
                        {
                            route: "tributacion-codigo-regimen",
                            title: "Código Régimen",
                            resource: "Tributacion",
                            action: "ver-tributacion-codigo-regimen",
                        },
                        {
                            route: "tributacion-parametrizacion-contribuyente",
                            title: "Parametrización Contribuyentes Proveedor",
                            resource: "Tributacion",
                            action: "ver-tributacion-parametrizacion-contribuyente",
                        },
                        {
                            route: "tributacion-SRI-Control-de-Errores-Usuarios-Contables",
                            title: "Control de Error Usuarios Contables",
                            resource: "Tributacion",
                            action: "ver-tributacion-SRI-Control-de-Errores-Usuarios-Contables",
                        },

                    ]
                },
                {
                    route: "tributacion-crear-provincia",
                    title: "Crear Provincia",
                    resource: "Tributacion",
                    action: "ver-tributacion-crear-provincia",
                },
            ]
        },
        {
            title: "Transacciones",
            fontIcon: "exchange-alt",
            resource: "Tributacion",
            action: "ver-tributacion-transacciones",
            children: [{
                    title: "RDEP",
                    resource: "Tributacion",
                    action: "ver-tributacion-rdep",
                    children: [{
                            route: "tributacion-migrar-excel",
                            title: "Migrar Excel",
                            resource: "Tributacion",
                            action: "ver-tributacion-migrar-excel",
                        },
                        {
                            route: "tributacion-procesos-RDEP",
                            title: "Generar XML ",
                            resource: "Tributacion",
                            action: "ver-tributacion-generar-xml",
                        },
                    ],
                },
                {
                    title: "ATS",
                    resource: "Tributacion",
                    action: "ver-tributacion-ATS",
                    children: [{
                        route: "tributacion-migrar-excel-ATS",
                        title: "Migrar ATS",
                        resource: "Tributacion",
                        action: "ver-tributacion-migrar-excel-ATS",
                    }, ],
                },
                //Diego
                {
                    route: "tributacion-transacciones-retenciones",
                    title: "Retenciones",
                    resource: "Tributacion",
                    action: "ver-tributacion-transacciones-retenciones",
                },
            ],
        },
        {
            title: "Informes",
            resource: "Tributacion",
            fontIcon: "file-prescription",
            action: "ver-tributacion-informes",
            children: [{
                    route: "tributacion-reporte-Form103",
                    title: "103",
                    resource: "Tributacion",
                    action: "ver-tributacion-reporte-103",
                },
                {
                    route: "tributacion-reporte-Form107",
                    title: "107",
                    resource: "Tributacion",
                    action: "ver-tributacion-reporte-107",
                },
                //DG
                {
                    route: "tributacion-reporte-ComprasServicios",
                    title: "Compras Servicios",
                    resource: "Tributacion",
                    action: "ver-tributacion-reporte-comprasServicios",
                },
                {
                    route: "tributacion-reportesRDEP-tabulador",
                    title: "Tabulador RDEP",
                    resource: "Tributacion",
                    action: "ver-tributacion-reporte-tabulado-rdep",
                },
                {
                    route: "tributacion-reporte-ventasat",
                    title: "AT Ventas",
                    resource: "Tributacion",
                    action: "ver-tributacion-reporte-ventasat",
                },
            ],
        },
    ]
}]
